import React from 'react';
import { connect } from 'react-redux';
import TextTranslate, { TextTranslateString } from '../../TextTranslate/TextTranslate';
import ValidationError from '../ValidationError';

const PersonalDetailsForm = ({values, errors, onChange, ...props}) => {

    const defaultFields = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        company: '',
        job_title: '',
    };

    const form = {...defaultFields, ...values};

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <form>
            <div className="form-row">
                <div className="form-group col-md-6 pr-sm-1 pr-lg-2 required">
                    <label><TextTranslate name="user-first-name" fallback="First Name"/></label>
                    <input
                        onChange={handleChange}
                        value={form.first_name}
                        name="first_name"
                        type="text"
                        className="form-control"
                        placeholder={TextTranslateString('user-first-name', 'First Name', props.currentLanguage, props.translations)}/>

                    <ValidationError errors={errors} name="first_name" />
                </div>
                <div className="form-group col-md-6 pl-sm-1 pl-lg-2  required">
                    <label><TextTranslate name="user-last-name" fallback="Last Name"/></label>
                    <input
                        onChange={handleChange}
                        value={form.last_name}
                        name="last_name"
                        type="text"
                        className="form-control"
                        placeholder={TextTranslateString('user-last-name', 'Last Name', props.currentLanguage, props.translations)}/>

                    <ValidationError errors={errors} name="last_name" />
                </div>
            </div>
            <div className="form-group required">
                <label><TextTranslate name="user-email-address" fallback="Email Address"/></label>
                <input
                    onChange={handleChange}
                    value={form.email}
                    name="email"
                    type="text"
                    className="form-control"
                    placeholder={TextTranslateString('user-email-address', 'Email Address', props.currentLanguage, props.translations)}/>

                <ValidationError errors={errors} name="email" />
            </div>
            <div className="form-group required">
                <label className="d-block mb-0"><TextTranslate name="user-phone-number" fallback="Phone Number"/></label>
                <span className="text-caption-1 text-color-gray d-block m-0 mb-2">
                    <TextTranslate name="form-phone-note" fallback="Please include area code."/>
                </span>
                <input
                    onChange={handleChange}
                    value={form.phone}
                    name="phone"
                    type="text"
                    placeholder="(+44)-XXX-XXX-XXX"
                    className="form-control"/>

                <ValidationError errors={errors} name="phone" />
            </div>
            <div className="form-row form-row-fluid">
                <div className="form-group col-md-6 pr-sm-1 pr-lg-2 required">
                    <label><TextTranslate name="user-company" fallback="Company"/></label>
                    <input
                        onChange={handleChange}
                        value={form.company}
                        name="company"
                        type="text"
                        className="form-control"
                        placeholder={TextTranslateString('user-company', 'Company name', props.currentLanguage, props.translations)}/>

                    <ValidationError errors={errors} name="company" />
                </div>
                <div className="form-group col-md-6 pl-sm-1 pl-lg-2 required">
                    <label><TextTranslate name="user-job-title" fallback="Job Title"/></label>
                    <input
                        onChange={handleChange}
                        value={form.job_title}
                        name="job_title"
                        type="text"
                        className="form-control"
                        placeholder={TextTranslateString('user-job-title', 'Job Title', props.currentLanguage, props.translations)}/>

                    <ValidationError errors={errors} name="job_title" />
                </div>
            </div>
        </form>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
	translations: state.translations?.translations
})

export default connect(mapStateToProps)(PersonalDetailsForm);
